/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    size: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    showBorder: {
      type: Boolean,
      default: false
    },
    borderWidth: {
      type: Number,
      default: 1
    },
    borderColor: {
      type: String,
      default: '#fff'
    },
    showBorderEffect: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      flag: false,
      // 没有用户头像
      userName: '' // 用户名

    };
  },
  computed: {
    // 计算宽度高度
    count: function count() {
      var sum;
      if (this.size === 1) sum = 140;
      if (this.size === 2) sum = 80;
      if (this.size === 3) sum = 44;
      if (this.size === 4) sum = 100;
      if (this.size === 5) sum = 50;
      if (this.size === 6) sum = 60;
      var num = parseFloat(sum / 25);
      return num + 'rem';
    }
  },
  watch: {
    url: function url(val) {
      this.load();
    },
    name: function name(val) {
      this.load();
    }
  },
  methods: {
    // 初始化
    load: function load() {
      if (this.size && !this.url) {
        this.flag = true;
        var str = this.name || '';
        var n = str.substr(str.length - 2, 2);
        this.userName = n;
      } else {
        this.flag = false;
      }
    },
    // 字体大小
    font: function font(size) {
      if (size) {
        var n;

        if ([1].indexOf(size) !== -1) {
          n = 36 / 2 + 'px';
        }

        if ([2, 4].indexOf(size) !== -1) {
          n = 26 / 2 + 'px';
        }

        if ([3, 5].indexOf(size) !== -1) {
          n = 18 / 2 + 'px';
        }

        return Number(n) / 12.5 + 'rem';
      }
    }
  },
  created: function created() {
    this.load();
  }
};